export type IMFieldList = IMField[];

export interface IMField {
  uuid: string; // 唯一标识
  name: string; // 名称
  description: string;
  color?: string; // 颜色
  combineName?: string; // 组合名称
  combineType?: EMFieldCombineType; // 组合类型
  level?: EMFieldLevel;
}

export enum EMFieldCombineType {
  combine = 'combine',
  char = 'char'
}

export enum EMFieldLevel {
  level1 = 'level1',
  level2 = 'level2',
  level3 = 'level3'
}

export interface IMFieldColumn {
  name: string;
  key: keyof IMField | 'operations';
}

export type IMFieldColumns = IMFieldColumn[];

export interface IMFieldLevelToColor {
  level1: string;
  level2: string;
  level3: string;
}
